"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var CookieConsentComponent = /*#__PURE__*/function () {
  function CookieConsentComponent() {
    _classCallCheck(this, CookieConsentComponent);

    var _this = this;

    this.cookieC = initCookieConsent();
    this.cookieC.run({
      current_lang: locale,
      autoclear_cookies: true,
      // default: false
      page_scripts: true,
      // default: false
      level: ["necessary", "analytics", "marketing"],
      onFirstAction: function onFirstAction(cookie) {
        cookie.action = "first_action";
        $.nette.ajax({
          url: linkCookiesLog,
          method: "POST",
          data: cookie
        });
      },
      onAccept: function onAccept(cookie) {
        gtag('consent', 'update', {
          ad_storage: cookie.level.includes("analytics") || cookie.level.includes("marketing") ? "granted" : "denied",
          analytics_storage: cookie.level.includes("analytics") ? "granted" : "denied",
          personalization_storage: cookie.level.includes("marketing") ? "granted" : "denied"
        });
      },
      onChange: function onChange(cookie, changed_categories) {
        cookie.action = "update";
        $.nette.ajax({
          url: linkCookiesLog,
          method: "POST",
          data: cookie
        });
        gtag('consent', 'update', {
          ad_storage: cookie.level.includes("analytics") || cookie.level.includes("marketing") ? "granted" : "denied",
          analytics_storage: cookie.level.includes("analytics") ? "granted" : "denied",
          personalization_storage: cookie.level.includes("marketing") ? "granted" : "denied"
        });
      },
      gui_options: {
        consent_modal: {
          layout: 'cloud',
          // box/cloud/bar
          position: 'bottom center',
          // bottom/middle/top + left/right/center
          transition: 'slide',
          // zoom/slide
          swap_buttons: false // enable to invert buttons

        },
        settings_modal: {
          layout: 'box',
          // box/bar
          position: 'right',
          // left/right
          transition: 'slide' // zoom/slide

        }
      },
      languages: _this.defineTranslate()
    });
  }

  _createClass(CookieConsentComponent, [{
    key: "defineTranslate",
    value: function defineTranslate() {
      var translates = {
        cs: {
          consent_modal: {
            title: 'Používáme cookies',
            description: 'Soubory cookie používáme k analýze údajů o našich návštěvnících, ke zlepšení našich webových stránek, zobrazení personalizovaného obsahu a k tomu, abychom vám poskytli skvělý zážitek z webu.',
            primary_btn: {
              text: 'Příjmout všechny',
              role: 'accept_all' // 'accept_selected' or 'accept_all'

            },
            secondary_btn: {
              text: 'Nastavení',
              role: 'settings' // 'settings' or 'accept_necessary'

            }
          },
          settings_modal: {
            title: 'Nastavení cookies',
            save_settings_btn: 'Uložit nastavení',
            accept_all_btn: 'Příjmout všechny',
            reject_all_btn: 'Odmítnout všechny',
            close_btn_label: 'Zavřít',
            cookie_table_headers: [{
              col1: 'Cookie'
            }, {
              col2: 'Doména'
            }, {
              col3: 'Expirace'
            }, {
              col4: 'Popis'
            }, {
              col5: 'Zpracovatel'
            }],
            blocks: [{
              title: 'Používáme Cookies',
              description: 'Soubory cookie používáme k analýze údajů o našich návštěvnících, ke zlepšení našich webových stránek, zobrazení personalizovaného obsahu a k tomu, abychom vám poskytli skvělý zážitek z webu.'
            }, {
              title: 'Funkční cookies',
              description: 'Tyto soubory cookie jsou nezbytné pro fungování webových stránek, není tedy možné je zakázat. Obvykle se nastavují v reakci na akci, kterou na webu sami provedete, jako je nastavení zabezpečení, přihlášení a vyplňování formulářů. Svůj prohlížeč můžete nastavit tak, aby blokoval soubory cookie nebo o nich zasílal upozornění. Mějte na paměti, že některé stránky nebudou bez těchto souborů fungovat. Tyto soubory cookie můžeme nastavit my nebo poskytovatelé třetích stran, jejichž služby na webu využíváme. Tyto soubory cookie neukládají žádné informace, které lze přiřadit ke konkrétní osobě.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"

              },
              cookie_table: [// list of all expected cookies
              {
                col1: 'banner',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '1 den',
                col4: 'Pro uložení informace o zobrazení akčního banneru',
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: 'cc_cookie',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '182 dní',
                col4: 'Ukládá souhlas uživatele s používáním cookies.',
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: 'PHPSESSID',
                col2: 'cskarlin.cz',
                col3: 'Relace',
                col4: 'Ukládá informace o uživatelově relaci.',
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: '_nss',
                col2: 'cskarlin.cz',
                col3: 'Relace',
                col4: 'Součást programovacího Frameworku',
                col5: 'BLOMUS s.r.o.'
              }]
            }, {
              title: 'Analytická cookies',
              description: 'Tyto soubory cookie jsou nezbytné pro fungování webových stránek, není tedy možné je zakázat. Obvykle se nastavují v reakci na akci, kterou na webu sami provedete, jako je nastavení zabezpečení, přihlášení a vyplňování formulářů. Svůj prohlížeč můžete nastavit tak, aby blokoval soubory cookie nebo o nich zasílal upozornění. Mějte na paměti, že některé stránky nebudou bez těchto souborů fungovat. Tyto soubory cookie můžeme nastavit my nebo poskytovatelé třetích stran, jejichž služby na webu využíváme. Tyto soubory cookie neukládají žádné informace, které lze přiřadit ke konkrétní osobě.',
              toggle: {
                value: 'analytics',
                // your cookie category
                enabled: false,
                readonly: false
              },
              cookie_table: [// list of all expected cookies
              {
                col1: '^_ga',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '2 roky',
                col4: 'Google Analytics - ukládá a počítá počet zobrazení stránek a chování webu',
                col5: 'Google Inc.',
                is_regex: true
              }, {
                col1: '_gat',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '1 minuta',
                col4: 'Google Analytics - ukládá a počítá počet zobrazení stránek a chování webu',
                col5: 'Google Inc.',
                is_regex: true
              }, {
                col1: '_gid',
                col2: 'cskarlin.cz',
                col3: '1 munuta',
                col4: 'Google Analytics - ukládá a počítá počet zobrazení stránek a chování webu',
                col5: 'Google Inc.'
              }]
            }, {
              title: 'Marketing cookies',
              description: 'Používají se ke sledování preferencí webu uživatele za účelem cílení reklamy, tj. zobrazování marketingových a reklamních sdělení (i na stránkách třetích stran), které mohou návštěvníka webu zajímat, v souladu s těmito preferencemi. Marketingové cookies využívají nástroje externích společností. Tyto marketingové soubory cookie budou použity pouze s vaším souhlasem.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }]
          }
        },
        en: {
          consent_modal: {
            title: 'We use cookies',
            description: 'We use cookies to analyse data about our visitors, to improve our website, to display personalised content and to give you a great web experience.',
            primary_btn: {
              text: 'Accept all',
              role: 'accept_all'
            },
            secondary_btn: {
              text: 'Settings',
              role: 'settings'
            }
          },
          settings_modal: {
            title: 'Cookies settings',
            save_settings_btn: 'Save settings',
            accept_all_btn: 'Accept all',
            reject_all_btn: 'Reject all',
            close_btn_label: 'Close',
            cookie_table_headers: [{
              col1: 'Cookie'
            }, {
              col2: 'Domain'
            }, {
              col3: 'Expiration'
            }, {
              col4: 'Description'
            }, {
              col5: 'Owner'
            }],
            blocks: [{
              title: 'We use Cookies',
              description: 'We use cookies to analyse data about our visitors, to improve our website, to display personalised content and to give you a great web experience.'
            }, {
              title: 'Functional cookies',
              description: 'These cookies are essential for the functioning of the website and cannot be disabled. They are usually set in response to an action you take on the website, such as setting security, logging in and filling in forms. You can set your browser to block cookies or send notifications about them. Keep in mind that some sites will not function without these files. These cookies may be set by us or by third party providers whose services we use on the site. These cookies do not store any information that can be associated with a specific person.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"

              },
              cookie_table: [// list of all expected cookies
              {
                col1: 'banner',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '1 day',
                col4: "To save information about the display of an action banner",
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: 'cc_cookie',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '182 days',
                col4: "Stores the user's consent to the use of cookies.",
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: 'PHPSESSID',
                col2: 'cskarlin.cz',
                col3: 'Sessions',
                col4: "Stores information about the user's session.",
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: '_nss',
                col2: 'cskarlin.cz',
                col3: 'Sessions',
                col4: 'Part of the Programming Framework',
                col5: 'BLOMUS s.r.o.'
              }]
            }, {
              title: 'Analytical cookies',
              description: 'These cookies are essential for the functioning of the website and cannot be disabled. They are usually set in response to an action you take on the website, such as setting security, logging in and filling in forms. You can set your browser to block cookies or send notifications about them. Keep in mind that some sites will not function without these files. These cookies may be set by us or by third party providers whose services we use on the site. These cookies do not store any information that can be associated with a specific person.',
              toggle: {
                value: 'analytics',
                // your cookie category
                enabled: false,
                readonly: false
              },
              cookie_table: [// list of all expected cookies
              {
                col1: '^_ga',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '2 year',
                col4: "Google Analytics - stores and counts the number of page views and website behaviour",
                col5: 'Google Inc.',
                is_regex: true
              }, {
                col1: '_gat',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '1 minute',
                col4: "Google Analytics - stores and counts the number of page views and website behaviour",
                col5: 'Google Inc.',
                is_regex: true
              }, {
                col1: '_gid',
                col2: 'cskarlin.cz',
                col3: '1 minute',
                col4: "Google Analytics - stores and counts the number of page views and website behaviour",
                col5: 'Google Inc.'
              }]
            }, {
              title: 'Marketing cookies',
              description: "They are used to track a user's website preferences for the purpose of targeting advertising, i.e. displaying marketing and advertising messages (including on third party sites) that may be of interest to the website visitor, in accordance with those preferences. Marketing cookies use tools from external companies. These marketing cookies will only be used with your consent.",
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }]
          }
        },
        ru: {
          consent_modal: {
            title: 'Мы используем файлы Печенье',
            description: 'Мы используем файлы cookie для анализа данных о наших посетителях, для улучшения нашего сайта, для отображения персонализированного контента и для того, чтобы обеспечить вам приятное времяпровождение в Интернете.',
            primary_btn: {
              text: 'Принять все',
              role: 'accept_all'
            },
            secondary_btn: {
              text: 'Настройки',
              role: 'settings'
            }
          },
          settings_modal: {
            title: 'Настройки Печенье',
            save_settings_btn: 'Сохранить настройки',
            accept_all_btn: 'Принять все',
            reject_all_btn: 'Отклонить все',
            close_btn_label: 'Закрыть',
            cookie_table_headers: [{
              col1: 'Печенье'
            }, {
              col2: 'Домен'
            }, {
              col3: 'Срок действия'
            }, {
              col4: 'Описание'
            }, {
              col5: 'Владелец'
            }],
            blocks: [{
              title: 'Мы используем файлы Печенье',
              description: 'Мы используем файлы cookie для анализа данных о наших посетителях, для улучшения нашего сайта, для отображения персонализированного контента и для того, чтобы обеспечить вам приятное времяпровождение в Интернете.'
            }, {
              title: 'Функциональные файлы Печенье',
              description: 'Эти файлы cookie необходимы для функционирования сайта и не могут быть отключены. Обычно они устанавливаются в ответ на действие, которое вы совершаете на сайте, например, при установке безопасности, входе в систему или заполнении форм. Вы можете настроить свой браузер на блокировку файлов cookie или отправку уведомлений о них. Имейте в виду, что некоторые сайты не будут функционировать без этих файлов. Эти файлы cookie могут быть установлены нами или сторонними поставщиками, чьи услуги мы используем на сайте. Эти файлы cookie не хранят никакой информации, которая может быть связана с конкретным человеком.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"

              },
              cookie_table: [// list of all expected cookies
              {
                col1: 'banner',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '1 день',
                col4: "Чтобы сохранить информацию об отображении баннера действия",
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: 'cc_cookie',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '182 дня',
                col4: "Сохраняет согласие пользователя на использование файлов Печенье.",
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: 'PHPSESSID',
                col2: 'cskarlin.cz',
                col3: 'Сессии',
                col4: "Хранит информацию о сессии пользователя.",
                col5: 'BLOMUS s.r.o.'
              }, {
                col1: '_nss',
                col2: 'cskarlin.cz',
                col3: 'Сессии',
                col4: 'Часть структуры программирования',
                col5: 'BLOMUS s.r.o.'
              }]
            }, {
              title: 'Аналитический Печенье',
              description: 'These cookies are essential for the functioning of the website and cannot be disabled. They are usually set in response to an action you take on the website, such as setting security, logging in and filling in forms. You can set your browser to block cookies or send notifications about them. Keep in mind that some sites will not function without these files. These cookies may be set by us or by third party providers whose services we use on the site. These cookies do not store any information that can be associated with a specific person.',
              toggle: {
                value: 'analytics',
                // your cookie category
                enabled: false,
                readonly: false
              },
              cookie_table: [// list of all expected cookies
              {
                col1: '^_ga',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '2 год',
                col4: "Google Analytics - хранит и подсчитывает количество просмотров страниц и поведение сайта",
                col5: 'Google Inc.',
                is_regex: true
              }, {
                col1: '_gat',
                // match all cookies starting with "_ga"
                col2: 'cskarlin.cz',
                col3: '1 минута',
                col4: "Google Analytics - хранит и подсчитывает количество просмотров страниц и поведение сайта",
                col5: 'Google Inc.',
                is_regex: true
              }, {
                col1: '_gid',
                col2: 'cskarlin.cz',
                col3: '1 минута',
                col4: "Google Analytics - хранит и подсчитывает количество просмотров страниц и поведение сайта",
                col5: 'Google Inc.'
              }]
            }, {
              title: 'Маркетинг Печенье',
              description: "Они используются для отслеживания предпочтений пользователя на сайте с целью таргетирования рекламы, то есть показа маркетинговых и рекламных сообщений (в том числе на сайтах третьих лиц), которые могут быть интересны посетителю сайта, в соответствии с этими предпочтениями. Маркетинговые файлы cookie используют инструменты внешних компаний. Эти маркетинговые файлы cookie будут использоваться только с вашего согласия.",
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              }
            }]
          }
        }
      };
      return translates;
    }
  }]);

  return CookieConsentComponent;
}();